var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix" },
    [
      _c(
        "div",
        {
          staticClass: "floL",
          class: { marTML: _vm.rowIdx > 0 },
          attrs: { id: _vm.getActivityAreaId(_vm.leftSide) + "-normal" }
        },
        [
          _c(
            "p",
            {
              staticClass: "fntH6 fntL bold padBSM",
              staticStyle: { color: "#2c2c2c" }
            },
            [_vm._v(_vm._s(_vm.leftSide.name) + "님의 액티비티")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "amway-theme" }, [
            _c(
              "div",
              { staticClass: "radio-wrapper pf23-active-radio pf23-radioBtn" },
              _vm._l(_vm.normalExamples, function(example) {
                return _c("SurveyActivityExample", {
                  key: "row" + _vm.rowIdx + "_left_" + example.se_code,
                  attrs: {
                    examples: _vm.normalExamples,
                    example: example,
                    attendant: _vm.leftSide,
                    unique: _vm.sqCode + "_row" + _vm.rowIdx + "_left"
                  }
                })
              }),
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.rightSide
        ? [
            _c(
              "div",
              {
                staticClass: "floR",
                class: { marTML: _vm.rowIdx > 0 },
                attrs: { id: _vm.getActivityAreaId(_vm.rightSide) + "-normal" }
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "fntH6 fntL bold padBSM",
                    staticStyle: { color: "#2c2c2c" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.rightSide.name || "배우자") + "님의 액티비티"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "amway-theme" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "radio-wrapper pf23-active-radio pf23-radioBtn"
                    },
                    _vm._l(_vm.normalExamples, function(example) {
                      return _c("SurveyActivityExample", {
                        key: "row" + _vm.rowIdx + "_right_" + example.se_code,
                        attrs: {
                          examples: _vm.normalExamples,
                          example: example,
                          attendant: _vm.rightSide,
                          unique: _vm.sqCode + "_row" + _vm.rowIdx + "_right"
                        }
                      })
                    }),
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.showBottomHr
              ? _c("hr", {
                  staticClass: "moOnly",
                  staticStyle: { "border-top": "1px solid #e3e3e3" }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59af4e9e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59af4e9e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/components/SurveyActivityPair.vue
// module id = null
// module chunks = 